import React from 'react'
import { TransitionLayout } from "@layouts/TransitionLayout"

const wrapWithLayout = ({ element, props }) => {
    return <TransitionLayout {...props}>{element}</TransitionLayout>
}

export default wrapWithLayout